import { get } from '../../services/utils'
import { useEffect, useRef, useState } from "react"
import { GET_MODELO } from "../../utils/constants"
import styles from '../../styles/modelos/ResultadoModeloForm.module.scss';

export default function ImagemModeloCell({ dataItem }: { dataItem: any }) {
    const [image, setImage] = useState('')
    const mounted = useRef(false)
    
    const getModelo = async (data: any) =>
    await get<any, any>(`${GET_MODELO}/` + data)

  
    useEffect(() => {
      const getModeloById = async () => {
      const result = await getModelo(dataItem?.id)
     
        if (result?.foto) {
          const base64Image = result.foto;
          setImage(base64Image)
        }
      }
  
      if (!mounted.current) {
        mounted.current = true
        getModeloById()
      }
    }, [])
  
    return (
      <td className="k-command-cell">
        <div className={styles.imagemCell}>
          {image && <img src={image} className={styles.imagem} />}
        </div>
      </td>
    )
  }